/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [category, setCategory] = useState([])

  const [apps, setApps] = useState([])
  const [loader, setLoader] = useState(true)

  const getAppTypes = async () => {
    const { response } = await AppService.Tools.get({
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getCategories = async () => {
    const { response } = await AppService.ToolCategory.get({
      toaster: false,
    })
    if (response) {
      setCategory(response.data)
    } else {
      setCategory([])
    }
  }

  const getApps = async () => {
    const { response, error } = await AppService.app.superadmin_apps()

    if (response) {
      setApps(response?.data);
    }
  }



  const onLoad = () => {
    getApps()
    getAppTypes()
    getCategories()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.Tools.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    apps: apps,
    category: category,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'description', accessor: 'description' },
        { Header: 'video_path', accessor: 'video_path' },
        { Header: 'category', accessor: 'category' },
        { Header: 'Apps', accessor: 'app_id' },



        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data.name,
        description: data.description
          ? `${data.description.replace(/<[^>]+>/g, "").substring(0, 20)}...`
          : "",
        video_path: data.video_path,
        category: data.category.name,
        app_id: data.app_id ? data.app_id.map(app => app.label).join(", ") : "",





        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} apps={apps} category={category} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
